<div class="flex basis-[7%] flex-row">
    <div class="flex flex-auto justify-start items-center content-center">
        <h1>CMS Files</h1>
    </div>
    <!-- <div class="flex">
        <button mat-flat-button class="primary-button-longtext my-auto" (click)="handleUploadButtonClick()"><mat-icon>add</mat-icon>&nbsp;Upload File</button>
    </div> -->
</div>

<div class="filter-section grid grid-cols-5 gap-3 p-3">
    <div>
        <app-payer-select
        [form]="form"
        [multiple]="true"
        [selectAllEnabled]="true"
        [queryOptions]="true"
        [required]="true"
        [filterByMORMap]="true"
        (ready)="handlePayerFieldReady()"
        (valueChanged)="handlePayerValueChange($event)"></app-payer-select>
    </div>
    <div>
        <app-upload-date
        [form]="form"
        [required]="true"
        (readyEvent)="handleUploadDateReady()"
        (valueChangedEvent)="handleUploadDateValueChange($event)"></app-upload-date>
    </div>
    <div>
        <app-file-type-select
        [form]="form"
        [required]="true"
        (readyEvent)="handleFileTypeReady()"
        (valueChangedEvent)="handleFileTypeValueChange($event)"></app-file-type-select>
    </div>
    <div class="pt-3">
        <button mat-flat-button class="primary-button"
          [disabled]="!generateEnabled"
          [matTooltip]="generateTooltip"
          [matTooltipClass]="'app-tooltip'"
        (click)="onGenerateReport()">Generate</button>
      </div>
</div>

<div class="grid-section flex-auto">
    <app-file-upload-table
        (export)="onExport($event)"></app-file-upload-table>
</div>